/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/sort-comp */
/* eslint-disable react/button-has-type */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HotKeys } from 'react-hotkeys';
import ContentEditable from 'react-contenteditable';
import cn from 'classnames';
import { head, groupBy, pick, some, isEqual } from 'lodash';

import { annotationType, dictionaryType, intentType } from 'types';
import MatchedIntentsFeatures from 'scenes/TestSets/components/MatchedIntentsFeatures';
import Underscores from './components/Underscores';
import MapToIntentIcon from './components/MapToIntentIcon';
import DictionaryPopup from './components/DictionaryPopup';
import MapToIntentPopup from './components/MapToIntentPopup';
import AnnotationPopup from './components/AnnotationPopup';
import ActionsMenu from './components/ActionsMenu';
import OriginalUtterancePopup from './components/OriginalUtterancePopup';
import { SOriginalUtternaceContainer, SIcon } from './styled';

import './style.scss';

const HOTKEYS_MAP = {
  shiftEnter: 'shift+enter',
  enter: 'enter',
  leave: 'esc',
};

const TAGS_REGEX = /<[^>]*>/g;
const GAPS_REGEX = /\s+/g;
const TAGS_AND_SPACE_REGEX = /<[^>]*>|&nbsp;/g;

const calculatePosition = event => {
  const { left, top } = event.target.getBoundingClientRect();
  const docHeight = document.documentElement.offsetHeight;
  const spaceFromTheBottomOfThePageInPxl = 220;
  const isAtTheBottomOfTheList =
    docHeight - spaceFromTheBottomOfThePageInPxl > top;
  const spaceFromIconInPxl = isAtTheBottomOfTheList ? 27 : -97;
  const updatedTopPosition = top + spaceFromIconInPxl;

  return { left, top: updatedTopPosition, isAtTheBottomOfTheList };
};

export class Entry extends Component {
  static propTypes = {
    closeIntentAndFeatureView: PropTypes.func,
    dictionaries: PropTypes.arrayOf(dictionaryType),
    entry: PropTypes.shape({
      id: PropTypes.string,
      initialValue: PropTypes.string,
      matched: PropTypes.shape({
        annotations: PropTypes.arrayOf(annotationType),
        utterance: PropTypes.string,
      }),
      order: PropTypes.number,
      value: PropTypes.string,
    }),
    intents: PropTypes.arrayOf(intentType),

    isAddingDictionary: PropTypes.bool,
    isLoadingAllIntents: PropTypes.bool,

    isLoadingDictionaries: PropTypes.bool,
    openIntentAndFeatureView: PropTypes.func,

    onAddDictionaryEntry: PropTypes.func,
    onAddEntry: PropTypes.func,
    onAddEntryAfter: PropTypes.func,
    onAddEntryBefore: PropTypes.func,
    onDeleteEntry: PropTypes.func,

    onGetAllIntents: PropTypes.func,
    onGetDictionaries: PropTypes.func,
    onGetIntent: PropTypes.func,
    onGoToIntent: PropTypes.func,
    onOpenNewIntentModal: PropTypes.func,
    onUpdateEntry: PropTypes.func,
    onUpdateIntent: PropTypes.func,
  };

  state = {
    areUnderscoresHidden: false,
    value: this.props.entry.value,
    isEditable: this.props.entry.value.length > 0,
    isHovered: false,
    annotationPopup: {
      token: '',
      isOpen: false,
      position: {},
      annotations: [],
    },
    actionsMenu: {
      isOpen: false,
      position: {},
    },
    dictionaryPopup: {
      isOpen: false,
      text: '',
      position: {},
      isAlignedToTop: true,
    },
    showOriginalUtterance: {
      isOpen: false,
      position: {},
    },
    mapToIntentPopup: {
      isOpen: false,
      position: {},
      isBelowIcon: false,
    },
  };

  componentDidMount() {
    if (this.props.entry.value.length === 0 && this.textarea) {
      this.textarea.htmlEl.focus();
    }
  }

  handleChange = event => {
    this.setState({
      value: event.target.value,
    });
  };

  handleBlur = async event => {
    event.stopPropagation();
    const { value } = this.state;
    const { onDeleteEntry, onUpdateEntry, onAddEntry, entry } = this.props;
    const entryLength = entry.value.length;

    // TODO: improve
    const trimValue = value
      .replace(TAGS_AND_SPACE_REGEX, ' ')
      .replace(GAPS_REGEX, ' ')
      .trim();

    if (trimValue) {
      if (entryLength > 0 && trimValue !== entry.value) {
        await onUpdateEntry(entry.id, {
          value: trimValue,
        });
      }
      if (entryLength === 0) {
        await onAddEntry({
          order: entry.order,
          value: trimValue,
        });
      }

      if (entryLength > 0) {
        this.setState({ isEditable: true, value: trimValue });
      }
    }

    if (trimValue === '') {
      await onDeleteEntry(entry);
    }
  };

  handleDoubleClick = e => {
    e.stopPropagation();
    this.setState(
      {
        isEditable: false,
        value: this.state.value.replace(TAGS_REGEX, ''),
      },
      () => {
        // set cursor position to the end when annotation is running
        const range = document.createRange();
        const sel = window.getSelection();
        range.setStart(this.textarea.htmlEl, 1);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);

        this.textarea.htmlEl.focus();
      },
    );
  };

  handleRef = ref => {
    this.textarea = ref;
  };

  handleKeyDown = e => {
    e.preventDefault();
    this.textarea.htmlEl.blur();
  };

  handleHotKeys = {
    enter: this.handleKeyDown,
    shiftEnter: this.handleKeyDown,
    esc: () => this.textarea.htmlEl.blur(),
  };

  handleMouseUp = e => {
    e.stopPropagation();
    const { isEditable, value } = this.state;
    const newValue = value.replace(TAGS_REGEX, '');
    const selObj = window.getSelection();
    const isOneItem = selObj.anchorNode
      ? selObj.anchorNode.nodeValue === newValue
      : false;

    if (
      e.button === 0 &&
      e.detail === 1 &&
      isOneItem &&
      isEditable &&
      !selObj.isCollapsed
    ) {
      const range = document.createRange();
      const { anchorOffset, anchorNode, focusOffset } = selObj;

      // different values when select text from left to right or from right to left
      const min = Math.min(anchorOffset, focusOffset);
      const max = Math.max(anchorOffset, focusOffset);

      const indexBefore = newValue.slice(0, min).lastIndexOf(' '); // getting new start index before selected text and after space
      const indexAfter = newValue.indexOf(' ', max); // getting new last index after selected text and before space

      const start = indexBefore !== -1 ? indexBefore + 1 : 0;
      const end = indexAfter !== -1 ? indexAfter : newValue.length;

      range.setStart(anchorNode, start); // sets the start position of a Range
      range.setEnd(anchorNode, end); // sets the end position of a Range.
      const text = range.toString();

      if (text.trim() !== '' && newValue.includes(text)) {
        const docHeight = document.documentElement.offsetHeight;
        const caretHeight = 15;
        const { width, height, left, top } = selObj
          .getRangeAt(0)
          .getBoundingClientRect();

        const newLeft = width / 2 + left - 48; // 48 - popup caret left position + caret width / 2
        const isAlignedToTop = docHeight - 205 > top;

        const newTop = isAlignedToTop
          ? { top: `${Math.round(top + height + caretHeight)}px` }
          : { bottom: `${Math.round(docHeight - top + caretHeight)}px` };

        const beforeStr = newValue.slice(0, start);
        const afterStr = newValue.slice(end);
        const value = `${beforeStr}<mark>${text}</mark>${afterStr}`;

        this.setState({
          value,
          dictionaryPopup: {
            isOpen: true,
            token: text,
            isAlignedToTop,
            position: {
              left: `${Math.round(newLeft)}px`,
              ...newTop,
            },
          },
        });

        this.props.onGetDictionaries({ page: 1, size: 100 });
      } else {
        selObj.removeAllRanges();
        this.handleDeselect();
      }
    }
  };

  handleMouseEnter = () => {
    this.setState({ isHovered: true });
  };

  handleMouseLeave = e => {
    const { isHovered, annotationPopup } = this.state;
    if (isHovered) {
      this.setState({ areUnderscoresHidden: false });
      // FIXME: drop it when annotationPopup render from list
      if (
        annotationPopup.isOpen &&
        !e.relatedTarget.closest('[class^=popup]')
      ) {
        this.setState({
          isHovered: false,
          annotationPopup: {
            isOpen: false,
          },
        });
      } else {
        this.setState({ isHovered: false });
      }
    }
  };

  isPublic = () => some(this.props.entry.matched.annotations, o => o.public);

  handleOpenModal = (token, position, annotations) => {
    const { annotationPopup } = this.state;
    if (
      (!annotationPopup.isOpen ||
        (!isEqual(position, annotationPopup.position) &&
          annotationPopup.isOpen)) &&
      !this.state.dictionaryPopup.isOpen
    ) {
      this.setState({
        annotationPopup: { isOpen: true, token, position, annotations },
      });
    }
  };

  handleCloseModal = () => {
    this.setState({ annotationPopup: { isOpen: false } });
  };

  handleOpenActionsMenu = e => {
    const { left, top } = e.target.getBoundingClientRect();
    const docHeight = document.documentElement.offsetHeight;
    const newTop = docHeight - 120 > top ? top : top - 120;

    this.setState({
      actionsMenu: {
        isOpen: true,
        position: {
          left: `${Math.round(left)}px`,
          top: `${Math.round(newTop)}px`,
        },
      },
    });
  };

  handleCloseActionsMenu = () => {
    this.setState({ actionsMenu: { isOpen: false } });
  };

  handleCloseDictionaryPopup = () => {
    this.setState({
      value: this.state.value.replace(TAGS_REGEX, ''),
      dictionaryPopup: { isOpen: false },
    });
  };

  handleOpenOriginalUtterance = event => {
    event.persist();
    const { left, top } = calculatePosition(event);
    const utteranceIconSizeInPxl = 19;

    this.setState(() => ({
      showOriginalUtterance: {
        isOpen: true,
        position: {
          left: `${Math.round(left + utteranceIconSizeInPxl)}px`,
          top: `${Math.round(top)}px`,
        },
      },
    }));
  };

  handleCloseOriginalUtterance = () => {
    this.setState({
      showOriginalUtterance: {
        isOpen: false,
      },
    });
  };

  handleOpenMapToIntentPopup = event => {
    if (this.isPublic()) {
      const { left, top, isAtTheBottomOfTheList } = calculatePosition(event);

      this.setState(
        {
          mapToIntentPopup: {
            isOpen: true,
            position: {
              left: `${Math.round(left - 176)}px`,
              top: `${Math.round(top)}px`,
            },
            isBelowIcon: !isAtTheBottomOfTheList,
          },
        },
        () => this.props.onGetAllIntents(),
      );
    }
  };

  handleCloseMapToIntentPopup = () => {
    this.setState({ mapToIntentPopup: { isOpen: false } });
  };

  renderMatchedIntents() {
    const {
      entry,
      entry: { matched },
      openIntentAndFeatureView,
      closeIntentAndFeatureView,
    } = this.props;

    if (matched && matched.intents.length > 0) {
      const intentsGroupedByScore = groupBy(matched.intents, 'score');
      const intentMaxScore = Math.max(...Object.keys(intentsGroupedByScore));
      const intentWithHighestScore = head(
        intentsGroupedByScore[intentMaxScore],
      );

      return (
        <MatchedIntentsFeatures
          closeIntentAndFeatureView={closeIntentAndFeatureView}
          item={entry}
          matchedIntent={pick(intentWithHighestScore, [
            'name',
            'color',
            'id',
            'source',
            'features',
          ])}
          openIntentAndFeatureView={openIntentAndFeatureView}
        />
      );
    }
    return null;
  }

  render() {
    const {
      entry: { matched, order },
      entry,
      onAddEntryBefore,
      onAddEntryAfter,
      onDeleteEntry,
      // Dictionaries
      dictionaries,
      onGetDictionaries,
      onAddDictionaryEntry,
      isLoadingDictionaries,
      isAddingDictionary,

      // Intents
      intents,
      onGetAllIntents,
      onUpdateIntent,
      onGetIntent,
      onGoToIntent,
      onOpenNewIntentModal,
      isLoadingAllIntents,
    } = this.props;
    const {
      isEditable,
      isHovered,
      value,
      annotationPopup,
      dictionaryPopup,
      mapToIntentPopup,
      showOriginalUtterance,
      actionsMenu,
      areUnderscoresHidden,
    } = this.state;
    const matchedIntents =
      matched &&
      matched.annotations.length > 0 &&
      matched.final_features.length > 0 &&
      matched.intents.length === 0;

    const shouldDisplayOriginalUtterance =
      matched &&
      matched.utterance &&
      matched.utterance !== entry.value &&
      isEditable;

    return (
      <HotKeys
        handlers={this.handleHotKeys}
        keyMap={HOTKEYS_MAP}
        styleName="wrap"
      >
        <div
          role="presentation"
          styleName="root"
          onDoubleClick={this.handleDoubleClick}
          onMouseDown={() => this.setState({ areUnderscoresHidden: true })}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          <div styleName="order">
            {isHovered && (
              <button
                className="icon-testset-raw-menu"
                onClick={this.handleOpenActionsMenu}
              />
            )}
            <span>{order + 1}.</span>
          </div>
          {!matched || !isEditable || areUnderscoresHidden ? (
            <ContentEditable
              ref={this.handleRef}
              disabled={isEditable}
              html={value}
              styleName={cn('item', {
                'is-unmarked': !dictionaryPopup.isOpen,
                'is-edit': !isEditable,
              })}
              tagName=""
              onBlur={this.handleBlur}
              onChange={this.handleChange}
              onMouseUp={this.handleMouseUp}
            />
          ) : (
            <Underscores
              matched={matched}
              value={matched.utterance ?? entry.value}
              onOpenModal={this.handleOpenModal}
            />
          )}
          {shouldDisplayOriginalUtterance && (
            <SOriginalUtternaceContainer>
              <SIcon
                glyph="process"
                size="19"
                onMouseEnter={event => this.handleOpenOriginalUtterance(event)}
                onMouseLeave={this.handleCloseOriginalUtterance}
              />
              {showOriginalUtterance.isOpen && (
                <OriginalUtterancePopup
                  position={showOriginalUtterance.position}
                  utterance={entry.value}
                />
              )}
            </SOriginalUtternaceContainer>
          )}
          {this.renderMatchedIntents()}
          {((isHovered && matchedIntents) || mapToIntentPopup.isOpen) && (
            <MapToIntentIcon
              isPublic={this.isPublic()}
              onOpen={this.handleOpenMapToIntentPopup}
            />
          )}

          {annotationPopup.isOpen && (
            <AnnotationPopup // TODO: move it to list component
              annotations={annotationPopup.annotations}
              position={annotationPopup.position}
              token={annotationPopup.token}
              onClose={this.handleCloseModal}
            />
          )}

          {actionsMenu.isOpen && (
            <ActionsMenu
              entry={entry}
              position={actionsMenu.position}
              onAddEntryAfter={onAddEntryAfter}
              onAddEntryBefore={onAddEntryBefore}
              onClose={this.handleCloseActionsMenu}
              onDeleteEntry={onDeleteEntry}
            />
          )}

          {dictionaryPopup.isOpen && (
            <DictionaryPopup
              dictionaries={dictionaries}
              isAdding={isAddingDictionary}
              isAlignedToTop={dictionaryPopup.isAlignedToTop}
              isLoading={isLoadingDictionaries}
              position={dictionaryPopup.position}
              token={dictionaryPopup.token}
              onAddDictionaryEntry={onAddDictionaryEntry}
              onClose={this.handleCloseDictionaryPopup}
              onGetDictionaries={onGetDictionaries}
            />
          )}

          {mapToIntentPopup.isOpen && (
            <MapToIntentPopup
              entry={entry}
              intents={intents}
              isBelowIcon={mapToIntentPopup.isBelowIcon}
              isLoading={isLoadingAllIntents}
              position={mapToIntentPopup.position}
              onClose={this.handleCloseMapToIntentPopup}
              onGetAllIntents={onGetAllIntents}
              onGetIntent={onGetIntent}
              onGoToIntent={onGoToIntent}
              onOpenNewIntentModal={onOpenNewIntentModal}
              onUpdateIntent={onUpdateIntent}
            />
          )}
        </div>
      </HotKeys>
    );
  }
}

export default Entry;
